var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.classes }, [
    _vm.$slots.primary
      ? _c(
          "div",
          { staticClass: "showmore-items__primary" },
          [_vm._t("primary")],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.$slots.secondary
      ? _c(
          "div",
          { staticClass: "showmore-items__secondary" },
          [
            !_vm.isExpanded
              ? _c("NavSidebarItem", {
                  attrs: {
                    "class-name": "nav-sidebar__item",
                    "is-selected": false
                  },
                  on: { click: _vm.toggleExpansion },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "text",
                        fn: function() {
                          return [
                            _vm._v(
                              "\n\t\t\t\t" +
                                _vm._s(
                                  _vm.$t("sidebar.ShowmoreItems_showMoreLabel")
                                ) +
                                "\n\t\t\t"
                            ),
                            _c("font-awesome-icon", {
                              attrs: { icon: ["fas", "angle-double-down"] }
                            })
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    false,
                    1842593534
                  )
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.isExpanded ? _vm._t("secondary") : _vm._e(),
            _vm._v(" "),
            _vm.isExpanded
              ? _c("NavSidebarItem", {
                  attrs: {
                    "class-name": "nav-sidebar__item",
                    "is-selected": false
                  },
                  on: { click: _vm.toggleExpansion },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "text",
                        fn: function() {
                          return [
                            _vm._v(
                              "\n\t\t\t\t" +
                                _vm._s(
                                  _vm.$t("sidebar.ShowmoreItems_showFewerLabel")
                                ) +
                                "\n\t\t\t"
                            ),
                            _c("font-awesome-icon", {
                              attrs: { icon: ["fas", "angle-double-up"] }
                            })
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    false,
                    2721423487
                  )
                })
              : _vm._e()
          ],
          2
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5247cffb", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5247cffb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sidebar/ShowmoreItems.vue
// module id = /3IA
// module chunks = 5